"use client";

import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Herobanner() {
  const [scrollY, setScrollY] = useState(0);
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.1
  });
  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section data-section-id="3161" id="herobanner" className="relative w-full h-screen min-h-[640px] overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 w-full h-[120%]" style={{
      transform: `translate3d(0, ${scrollY * 0.4}px, 0)`,
      willChange: "transform"
    }}>
        <video autoPlay loop muted playsInline poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1727079/img/medical_innovation_hero.png" className="absolute inset-0 w-full h-full object-cover">
          <source src="/img/medical_innovation_hero.mp4" type="video/mp4" />
        </video>
        {}
        <div className="absolute inset-0" style={{
        background: "linear-gradient(180deg, hsla(220, 40%, 10%, 0.6) 0%, hsla(220, 40%, 10%, 0.3) 35%, hsla(220, 40%, 10%, 0.5) 70%, hsla(220, 40%, 10%, 0.8) 100%)"
      }} />
        {}
        <div className="absolute inset-0" style={{
        background: "radial-gradient(ellipse at center, transparent 40%, hsla(220, 40%, 10%, 0.6) 100%)"
      }} />
      </div>

      {}
      <div className="absolute top-8 right-6 md:top-12 md:right-10 z-20 hidden sm:flex flex-col items-center gap-3">
        <span className="font-default text-[10px] tracking-[0.4em] uppercase" style={{
        color: "hsla(178, 65%, 72%, 0.8)",
        writingMode: "vertical-rl"
      }}>
          Scroll
        </span>
        <div className="relative w-px h-16 overflow-hidden" style={{
        backgroundColor: "hsla(178, 65%, 72%, 0.2)"
      }}>
          <div className="absolute top-0 left-0 w-full h-6 animate-[scrollLine_2.4s_ease-in-out_infinite]" style={{
          background: "linear-gradient(180deg, transparent 0%, hsla(178, 65%, 72%, 0.9) 50%, transparent 100%)"
        }} />
        </div>
      </div>

      {}
      <div className="relative z-10 h-full w-full max-w-7xl mx-auto px-6 md:px-10 lg:px-16 flex flex-col justify-end pb-20 md:pb-24 lg:pb-28">
        <div ref={contentRef} className={`max-w-3xl transition-all duration-[1400ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <p className="font-default text-[10px] md:text-xs tracking-[0.35em] uppercase mb-6 md:mb-8" style={{
          color: "hsl(178 65% 72%)"
        }}>
            全球醫療採購 · 戰略配銷
          </p>

          {}
          <h1 className="font-default font-bold text-white mb-6 md:mb-8" style={{
          fontSize: "clamp(3.5rem, 9vw, 8rem)",
          lineHeight: "0.95",
          letterSpacing: "-0.02em"
        }}>
            連接
            <br />
            <em className="not-italic" style={{
            color: "hsl(178 65% 72%)"
          }}>
              全球創新
            </em>
          </h1>

          {}
          <p className="font-default text-base md:text-lg max-w-xl mb-8 md:mb-10 leading-relaxed text-white/90">
            MS BIOTECHNOLOGY 是您值得信賴的合作夥伴，致力於為全球醫療專業人員採購、評估及分銷優質醫療技術。
          </p>

          {}
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4 sm:gap-5">
            <Button asChild size="lg" className="h-12 px-8 rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 font-default text-sm tracking-wide shadow-lg">
              <Link to="/OurProductsPage">查看我們的解決方案</Link>
            </Button>
            <Button asChild variant="link" className="h-12 px-2 justify-start sm:justify-center font-default text-sm tracking-wide hover:no-underline group text-white">
              <Link to="/CompliancePage" className="inline-flex items-center gap-2">
                <span className="relative">
                  我們的品質標準
                  <span className="absolute left-0 -bottom-1 h-px w-full origin-left scale-x-100 transition-transform duration-500 group-hover:scale-x-0 bg-white/40" />
                </span>
                <ArrowRight className="w-4 h-4 transition-transform duration-500 group-hover:translate-x-1" />
              </Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className={`absolute z-10 hidden md:block bottom-24 right-10 lg:right-16 transition-all duration-[1600ms] delay-300 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        <Link to="/OurProductsPage" className="group block backdrop-blur-sm rounded-lg p-3 pr-5 transition-all duration-500 hover:scale-[1.02] bg-white/10 border border-white/20 shadow-lg">
          <div className="flex items-center gap-4">
            <div className="relative w-14 h-14 rounded-md overflow-hidden flex-shrink-0">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1727079/img/medical_device_showcase.webp" alt="Advanced Medical Device" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
            </div>
            <div className="flex flex-col">
              <span className="font-default text-[9px] tracking-[0.3em] uppercase mb-1 text-primary">
                Featured
              </span>
              <span className="font-default text-base leading-tight text-white">
                診斷系統
              </span>
            </div>
            <ArrowRight className="w-4 h-4 ml-2 transition-transform duration-500 group-hover:translate-x-1 text-white/70" />
          </div>
        </Link>
      </div>

      {}
      <div className="absolute z-10 md:hidden bottom-6 left-6 right-6">
        <Link to="/OurProductsPage" className="flex items-center gap-3 backdrop-blur-sm rounded-lg p-3 bg-white/10 border border-white/20">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1727079/img/medical_device_showcase.webp" alt="Advanced Medical Device" loading="lazy" decoding="async" className="w-10 h-10 rounded-md object-cover flex-shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="font-default text-[8px] tracking-[0.3em] uppercase mb-0.5 text-primary">
              Featured
            </p>
            <p className="font-default text-sm truncate text-white">
              診斷系統
            </p>
          </div>
          <ArrowRight className="w-4 h-4 flex-shrink-0 text-white/70" />
        </Link>
      </div>

      <style>{`
        @keyframes scrollLine {
          0% { transform: translateY(-100%); }
          100% { transform: translateY(400%); }
        }
      `}</style>
    </section>;
}